@if (mergeFieldTables) {
    <cerrix-collapsing-box boxTitle="Merge Fields" [isCollapsed]="true">
        <ng-template #content>
            @for (mergeFieldTable of mergeFieldTables; track mergeFieldTable) {
                <div class="title">
                    <span>{{ mergeFieldTable.title }}</span>
                    @if (mergeFieldTable.description) {
                        <i
                            class="far fa-info-circle ms-1"
                            [tooltip]="mergeFieldTable.description"
                        ></i>
                    }
                </div>
                <div class="data-grid">
                    @for (mergeField of mergeFieldTable.fields; track mergeField) {
                        <div class="header">
                            <span>{{ mergeField.name }}</span>
                            @if (mergeField.description) {
                                <i
                                    class="far fa-info-circle ms-1"
                                    [tooltip]="mergeField.description"
                                ></i>
                            }
                        </div>
                        <div class="value">
                            <span>{{ mergeField.fieldName }}</span>
                            <i
                                class="copy-button far fa-clipboard-list ms-1"
                                tooltip="Copy to clipboard"
                                (click)="copyField(mergeField.fieldName)"
                            ></i>
                        </div>
                    }
                </div>
            }
        </ng-template>
    </cerrix-collapsing-box>
}
